import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CodeExportMain from './code-export/CodeExportMain';
import { checkCodeExportPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import ExportNav from './ExportNav';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class CodeExport extends Component {
  static propTypes = {
    deploymentSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  // upgradeAccountEmail = () => {
  //   const { actions, match } = this.props;
  //   const { projectId } = match.params;
  //   actions.requestUpgradeAccount({ projectId, code: permissionTypes.CODE_EXPORT });
  // };

  render() {
    const { deploymentSetting, match } = this.props;
    const { projectId, version } = match.params;
    const { enableCodeExport, projectDetail } = deploymentSetting;
    const projectType = projectDetail && projectDetail.projectType ? projectDetail.projectType : '';
    const isAllowed = checkCodeExportPermission();
    const isReadOnly = isProjectReadOnly(projectId);
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Code Export" />
        </CommonPageComponent>
      );
    }
    return (
      <CommonPageComponent>
        <ExportNav activeTab={'codeExport'} version={version} projectId={projectId} />
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <CodeExportMain projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    deploymentSetting: state.deploymentSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CodeExport);
